(() => {
  const nav = document.querySelector('[data-collection-nav]');
  if (!nav) return;

  const update = () => {
    const stickyTop = parseFloat(getComputedStyle(nav).top) || 0;
    const isStuck = window.scrollY > 0 && nav.getBoundingClientRect().top <= stickyTop + 1;
    nav.classList.toggle('is-stuck', isStuck);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();
